
import React from 'react';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { VaultProvider } from './contexts/VaultContext';
import { DataProvider } from './contexts/DataContext';
import AppRouter from './components/AppRouter';

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <AuthProvider>
        <VaultProvider>
          <DataProvider>
            <AppRouter />
          </DataProvider>
        </VaultProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
